export default __webpack_public_path__ + "static/media/collections_6.f9d40b8d.jpg";